// extracted by mini-css-extract-plugin
export default {"linkContainer":"Components_linkContainer__gW14B","removeBold":"Components_removeBold__+0b7o","userInput":"Components_userInput__N74hC"};